import Vue from "vue";

export const ACTION_APP_INCREMENT = 'ActionAppIncrement'
export const ACTION_APP_DECREMENT = 'ActionAppDecrement'


// define app store mutations names
const INCREMENT_VALUE = 'IncrementValue'
const DECREMENT_VALUE = 'DecrementValue'

export default {
    state: {
        counter: 0,
        solar: 0,
        agMeter1: 0,
        agMeter2: 0,
        agMeter3: 0,
        electricityCoefficient: .252,
        electricityCoefficientProvider: "PG&E",
        tonnageCoefficient: 2204.6,
        totalNaturalGas: 100,
        totalPropane: 200,
        totalGasoline: 300,
        totalDiesel: 400,
        ///////////////////
        solid: 0,
        liquid: 0,
        compost: 0,
        manure: 0,
        ///////Yield Data////
        totalTons: 0,
        vineyardAcreage: 0,
        ///////Water Data//////
        irrigation: 0,
        frost: 0,
        other: 0,
        other2: 0,
        groupId: '6058a714d2779226a36d025d',
        year: 2023,
        currentMetricsGroupId: '',
        vineyardProductionId: '',
        calculationType: 'PG&E',
        calculationTypeId: '',
        co2CalcTypes: ['PG&E', 'MCE Light Green', 'MCE Deep Green']
    },

    getters: {
        getCounter(state) {
            return state.counter
        },
        electricityEmissions(state) {
            let electricity = ((state.solar + state.agMeter1 + state.agMeter2 + state.agMeter3)
                * state.electricityCoefficient) / state.tonnageCoefficient;
            return electricity.toFixed(1);
        },
        naturalGasEmissions(state) {
            let naturalGas = (state.totalNaturalGas * 11.7) / state.tonnageCoefficient;
            return naturalGas.toFixed(1);
        },
        propaneEmissions(state) {
            console.log(`Vuex Get Propane: ${state.totalPropane}`)
            let propane = (state.totalPropane * 12.7) / state.tonnageCoefficient;
            return propane.toFixed(1);
        },
        gasolineEmissions(state) {
            let gasoline = (state.totalGasoline * 19.6) / state.tonnageCoefficient;
            return gasoline.toFixed(1);
        },
        dieselEmissions(state) {
            let diesel = (state.totalDiesel * 22.2) / state.tonnageCoefficient;
            return diesel.toFixed(1);
        },
        totalCO2PerTon(state) {
            console.log("totalCO2PerTON initial")
            console.log("totalCO2PerTON" + state.totalTons)
            if (state.totalTons === 0) {
                return 0.0;
            }
            let electricity = ((state.solar + state.agMeter1
                    + state.agMeter2 + state.agMeter3)
                * state.electricityCoefficient) / state.tonnageCoefficient;
            let naturalGas = (state.totalNaturalGas * 11.7) / state.tonnageCoefficient;
            let propane = (state.totalPropane * 12.7) / state.tonnageCoefficient;
            let gasoline = (state.totalGasoline * 19.6) / state.tonnageCoefficient;
            let diesel = (state.totalDiesel * 22.2) / state.tonnageCoefficient;
            let co2PerTon = (electricity + naturalGas + propane + gasoline + diesel) / state.totalTons;
            return co2PerTon.toFixed(2);
        },
        totalCO2e: function (state) {
            if (state.vineyardAcreage === 0) {
                return 0.0;
            }
            let electricity = ((state.solar + state.agMeter1 + state.agMeter2 + state.agMeter3) * state.electricityCoefficient) / state.tonnageCoefficient;
            let naturalGas = (state.totalNaturalGas * 11.7) / state.tonnageCoefficient;
            let propane = (state.totalPropane * 12.7) / state.tonnageCoefficient;
            let gasoline = (state.totalGasoline * 19.6) / state.tonnageCoefficient;
            let diesel = (state.totalDiesel * 22.2) / state.tonnageCoefficient;
            let co2PerTotal = (electricity + naturalGas + propane + gasoline + diesel);
            //state.sendUpdateTotalCo2Update(co2PerTotal);
            return co2PerTotal.toFixed(2);
        }/**/,
        vineyardAcreage(state, vineyardAcreage) {
            return state.vineyardAcreage;
        },
        totalTons(state, totalTons) {
            return state.totalTons;
        },
        currentMetricsGroupId(state) {
            return state.currentMetricsGroupId;
        },
        selectedMetricYear(state) {
            return state.year;
        },
        vineyardProductionId(state) {
            console.log('Getter called, state value:', state.vineyardProductionId)
            console.log('State object:', state)
            return state.vineyardProductionId;
        },
        totalElectricityPerTon(state) {
            if (state.totalTons === 0) {
                return 0;
            }
            let electricityPerTon = (state.solar + state.agMeter1 + state.agMeter2 + state.agMeter3) / state.totalTons;
            console.log(`Electricity isNaN: ${isNaN(electricityPerTon)}`)
            console.log(`Electricity Per Ton Unrounded: ${electricityPerTon}`)
            return isNaN(electricityPerTon) ? 0 : electricityPerTon.toFixed(1);
        },
        waterPerAcre: function (state) {
            if (state.totalTons === 0) {
                return 0;
            }
            let waterPerTon = (state.irrigation + state.frost + state.other + state.other2) / state.vineyardAcreage;
            return isNaN(waterPerTon) ? 0 : waterPerTon.toFixed(1);
        },
        waterPerTon: function (state) {
            if (state.totalTons === 0) {
                return 0;
            }
            let waterPerTon = (state.irrigation + state.frost + state.other + state.other2) / state.totalTons;
            return isNaN(waterPerTon) ? 0 : waterPerTon.toFixed(1);
        },
        totalCo2ePerTon: function (state, getters) {
            if (state.totalTons === 0) {
                return 0;
            }
            let co2ePerTon = (getters.totalCO2e) / state.vineyardAcreage;
            return isNaN(co2ePerTon) ? 0 : co2ePerTon.toFixed(1);
        },
        calculationType(state) {
            return state.calculationType;
        },
        calculationTypeId(state) {
            return state.calculationTypeId;
        },
        co2CalcTypes(state) {
            return state.co2CalcTypes;
        }
    },

// app store actions
    actions: {
        [ACTION_APP_INCREMENT](context) {
            context.commit(INCREMENT_VALUE);
        },
        [ACTION_APP_DECREMENT](context) {
            context.commit(DECREMENT_VALUE);
        },
        /** Where to call this from for autosave **/
        postCalculationType: function (context, calcType) {
            let self = this;
            Vue.prototype.$http.post('metrics/calculation/type', calcType
                , {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(response => {
                context.commit('calculationTypeId', response.data.id);
                console.log(response);
            });
        },
        putCalculationType(context, calcType) {
            Vue.prototype.$http.put('metrics/calculation/type', calcType
                , {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(response => {
                console.log(response);
            });
        },
        loadProductionData(context, commit, getters, rootGetters) {
            console.log("Loading Production Data");
            let va = 0;
            let tt = 0;
            let vineyardProductionId = '';
            let self = this;
            let groupIdVal = context.getters.currentMetricsGroupId;
            let year = context.state.year
            console.log("GroupId from userStore: ", groupIdVal);
            Vue.prototype.$http.get(`metrics/production/data/vineyard/${groupIdVal}/${year}`)
                .then(result => {
                    console.log(`Vineyard Production Data: ${result.data}`)
                    if (result.data !== null) {
                        let prodData = result.data;
                        vineyardProductionId = prodData._id;
                        console.log(`Vineyard Production Id: ${vineyardProductionId}`)
                        va = prodData.vineyardAcreage;
                        tt = prodData.totalTons;
                        context.commit('vineyardProductionId', vineyardProductionId);
                        context.commit('vineyardAcreage', va);
                        context.commit('totalTons', tt);
                        console.log(`Vineyard Production Data: `, prodData);
                    }
                }).catch(err => {
                console.log(err)
            });
        },
        updateProductionData: function (context) {

            let vineyardProductionId = context.getters.vineyardProductionId;
            let vineyardProduction = {
                _id: vineyardProductionId,
                groupId: context.getters.currentMetricsGroupId,
                vineyardAcreage: context.getters.vineyardAcreage,
                totalTons: context.getters.totalTons,
                year: context.getters.selectedMetricYear
            }

            let vineyardProductionJson = JSON.stringify(vineyardProduction, null, 3);
            Vue.prototype.$http.post("metrics/production/data/vineyard/" + vineyardProductionId, vineyardProductionJson
                , {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(response => {
                if (vineyardProductionId === undefined || vineyardProductionId === '') {
                    context.commit("vineyardProductionId", response.data._id);
                }
                console.log("Production Data Post", response);
            });
        },
        loadCalculationType: function (context) {
            console.log("Load Calculation Type");
            let self = this;
            let groupId = context.getters["user/groupId"];
            let metricYear = context.getters.selectedMetricYear;
            Vue.prototype.$http.get(`metrics/calculation/type/${groupId}/${metricYear}`)
                .then(result => {
                    if (result.data && result.data !== "") {
                        let vineyardCalculationType = result.data;
                        self.calculationType = vineyardCalculationType.calculationType;
                        self.calculationTypeId = vineyardCalculationType.id;
                    }
                })
                .catch(err => {
                    this.handleError(err);
                    //this.$nextTick(this.sendUpdate(this.year))
                });
        }
    },

// app store mutations
    mutations: {
        [INCREMENT_VALUE](state) {
            state.counter = state.counter + 1

            console.log('New counter value: ' + state.counter)
        },
        [DECREMENT_VALUE](state) {
            state.counter = state.counter - 1

            console.log('New counter value: ' + state.counter)
        },
        solar(state, newSolarValue) {
            state.solar = newSolarValue;
        },
        agMeter1(state, newVal) {
            state.agMeter1 = newVal;
        },
        agMeter2(state, newVal) {
            state.agMeter2 = newVal;
        },
        agMeter3(state, newVal) {
            state.agMeter3 = newVal;
        },
        calcAndUpdateVineyardPowerData(state, powerData) {
            let solarAdder = 0;
            let ag1Adder = 0;
            let ag2Adder = 0;
            let ag3Adder = 0;
            powerData.months.forEach(data => {
                solarAdder = solarAdder + data.solar;
                ag1Adder = ag1Adder + data.ag1;
                ag2Adder = ag2Adder + data.ag2;
                ag3Adder = ag3Adder + data.ag3;
            });
            state.solar = solarAdder;
            state.agMeter1 = ag1Adder;
            state.agMeter2 = ag2Adder;
            state.agMeter3 = ag3Adder;
            console.log(`Solar value: ${solarAdder}`);
        },
        calcAndUpdateVineyardFertilizerData(state, fertilizerData) {
            let solidAdder = 0;
            let liquidAdder = 0;
            let compostAdder = 0;
            let manureAdder = 0;
            fertilizerData.months.forEach(data => {
                solidAdder = solidAdder + data.solid;
                liquidAdder = liquidAdder + data.liquid;
                compostAdder = compostAdder + data.compost;
                manureAdder = manureAdder + data.manure;
            });
            state.solid = solidAdder;
            state.liquid = liquidAdder;
            state.compost = compostAdder;
            state.manure = manureAdder;
            console.log(`Solid value: ${solidAdder}`);
        },
        calcAndUpdateVineyardGasData(state, fertilizerData) {
            let naturalGasAdder = 0;
            let propaneAdder = 0;
            let gasolineAdder = 0;
            let dieselAdder = 0;
            fertilizerData.months.forEach(data => {
                naturalGasAdder += data.naturalGas;
                propaneAdder += data.propane;
                gasolineAdder += data.gasoline;
                dieselAdder += data.diesel;
            });

            state.totalNaturalGas = naturalGasAdder;
            state.totalPropane = propaneAdder;
            state.totalGasoline = gasolineAdder;
            state.totalDiesel = dieselAdder;
            console.log(`Vuex Natural gas: ${naturalGasAdder}`);
            console.log(`Vuex Natural propane: ${state.totalPropane}`);
        },
        calcAndUpdateVineyardWaterData(state, waterData) {
            let irrigationAdder = 0;
            let frostAdder = 0;
            let otherAdder = 0;
            let other2Adder = 0;
            waterData.months.forEach(data => {
                irrigationAdder += data.irrigation;
                frostAdder += data.frost;
                otherAdder += data.other;
                other2Adder += data.other2;
            });

            state.irrigation = irrigationAdder;
            state.frost = frostAdder;
            state.other = otherAdder;
            state.other2 = other2Adder;
            console.log(`Vuex Irrigation: ${state.irrigation}`);
            console.log(`Vuex Frost: ${state.frost}`);
        },
        totalNaturalGas(state, gas) {
            state.totalNaturalGas = gas;
        },
        totalPropane(state, propane) {
            console.log(`Vuex Set propane: ${state.totalPropane}`)
            state.totalPropane = propane;
        },
        totalGasoline(state, gas) {
            state.totalGasoline = gas;
        },
        totalDiesel(state, diesel) {
            state.totalDiesel = diesel;
        },
        totalTons(state, totalTons) {
            state.totalTons = totalTons;
        },
        vineyardAcreage(state, vineyardAcreage) {
            console.log(`Setting VineyardAcreage Vuex: ${vineyardAcreage}`);
            state.vineyardAcreage = vineyardAcreage;
        },
        currentMetricsGroupId(state, groupId) {
            state.currentMetricsGroupId = groupId;
        },
        vineyardProductionId(state, vineyardProductionId) {
            state.vineyardProductionId = vineyardProductionId;
        },
        selectedMetricYear(state, selectedMetricsYear) {
            state.year = selectedMetricsYear;
        },
        calculationType(state, calculationType) {
            state.calculationType = calculationType;
            let coefficient;
            let provider;
            switch (state.calculationType) {
                case "PG&E":
                    coefficient = .252;
                    provider = "PG&E";
                    break;
                case "MCE Light Green":
                    coefficient = .127;
                    provider = "MCE Light Green";
                    break;
                case "MCE Deep Green":
                    coefficient = 0;
                    provider = "MCE Deep Green";
                    break;
                default:
                    coefficient = .252;
                    provider = "PG&E";
                    break;
            }
            state.electricityCoefficient = coefficient;
        },
        calculationTypeId(state, calculationTypeId) {
            state.calculationTypeId = calculationTypeId;
        },
        irrigation(state, irrigation) {
            state.irrigation = irrigation;
        },
        frost(state, frost) {
            state.frost = frost;
        },
        other(state, other) {
            state.other = other;
        },
        other2(state, other2) {
            state.other2 = other2;
        },
        solid(state, solid) {
            state.solid = solid;
        },
        liquid(state, liquid) {
            state.liquid = liquid;
        },
        compost(state, compost) {
            state.compost = compost;
        },
        manure(state, manure) {
            state.manure = manure;
        },
    }
}
